import { GetPlaceBehaviorResponse } from '@/features/places/types/places.type';
import {
	Action,
	GeofenceMode,
} from '@/OptimusRoutes/pages/MainMap/components/ControlPanel/GeofencePanel/store/geofencePanelActions';
import { ActionType } from '@/types/actionType';

type State = {
	currentMode: GeofenceMode;
	behaviorToEdit: GetPlaceBehaviorResponse | null;
	isLoading: boolean;
};
const INITIAL_STATE: State = {
	currentMode: 'list',
	behaviorToEdit: null,
	isLoading: false,
};

const geofencePanelReducer = (state: State = INITIAL_STATE, action: Action): State => {
	switch (action.type) {
		case ActionType.GEOFENCE_PANEL_SET_CURRENT_MODE:
			return {
				...state,
				currentMode: action.payload,
			};

		case ActionType.GEOFENCE_PANEL_SET_BEHAVIOR_TO_EDIT:
			return {
				...state,
				behaviorToEdit: action.payload,
			};

		case ActionType.GEOFENCE_PANEL_SET_LOADING:
			return {
				...state,
				isLoading: action.payload,
			};

		default:
			return state;
	}
};

export default geofencePanelReducer;
